<template>
  <div>
    <h6 class="font-weight-bold text-nowrap text-medium">
      {{ name }}
    </h6>
    <div class="sep-small mb-3 mt-2" />
  </div>
</template>

<script>
export default {
  name: 'OperationsTitle',
  props: {
    name: { type: String, required: true },
  },
};
</script>

<style scoped>
</style>
